var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicCaption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.51 19.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#97999b;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "connect"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 60.51,
    height: 19.65,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.86,10.12c0-2.55,1.64-4,3.59-4a3.15,3.15,0,0,1,2.26,1l-.81,1a2,2,0,0,0-1.42-.65c-1.17,0-2.05,1-2.05,2.66s.8,2.69,2,2.69A2.14,2.14,0,0,0,13,12l.82,1a3.15,3.15,0,0,1-2.47,1.14C9.44,14.09,7.86,12.69,7.86,10.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.71,12h-2.5l-.54,2H14.1l2.48-7.72h1.81l2.48,7.72H19.26Zm-.33-1.2-.23-.84c-.24-.81-.45-1.69-.68-2.53h0c-.2.85-.43,1.72-.66,2.53l-.23.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.78,6.22h2.53c1.71,0,3,.6,3,2.42s-1.33,2.56-3,2.56h-1v2.74H21.78ZM24.25,10c1.07,0,1.58-.45,1.58-1.34s-.57-1.2-1.63-1.2h-.88V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.07,7.51H27.9V6.22h5.9V7.51H31.61v6.43H30.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.05,6.22H36.6v7.72H35.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.11,10.05c0-2.51,1.41-4,3.45-4S45,7.55,45,10.05s-1.4,4-3.45,4S38.11,12.56,38.11,10.05Zm5.33,0c0-1.66-.73-2.65-1.88-2.65s-1.88,1-1.88,2.65.73,2.7,1.88,2.7S43.44,11.7,43.44,10.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.52,6.22H48.1l2.24,4.11L51.11,12h.06A25.55,25.55,0,0,1,51,9.3V6.22h1.46v7.72H50.86L48.63,9.81l-.78-1.66H47.8c.07.84.19,1.81.19,2.7v3.09H46.52Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicCaption);
export default __webpack_public_path__ + "static/media/publicCaption.ee76b9839905763d03d8dfc03c15d407.svg";
export { ForwardRef as ReactComponent };